import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          backgroundColor: '#f5f5f7',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          <div style={{
            maxWidth: '500px',
            textAlign: 'center',
            backgroundColor: 'white',
            padding: '3rem',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '1rem'
            }}>
              😕
            </div>
            <h1 style={{
              fontSize: '24px',
              fontWeight: '600',
              marginBottom: '1rem',
              color: '#1d1d1f'
            }}>
              Something went wrong
            </h1>
            <p style={{
              fontSize: '16px',
              color: '#6e6e73',
              marginBottom: '2rem',
              lineHeight: '1.5'
            }}>
              We're sorry for the inconvenience. Please try refreshing the page.
            </p>
            <button
              onClick={this.handleRefresh}
              style={{
                backgroundColor: '#06c',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#0077ed'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#06c'}
            >
              Refresh Page
            </button>
            {import.meta.env.DEV && this.state.error && (
              <details style={{
                marginTop: '2rem',
                textAlign: 'left',
                backgroundColor: '#f5f5f7',
                padding: '1rem',
                borderRadius: '8px',
                fontSize: '14px'
              }}>
                <summary style={{
                  cursor: 'pointer',
                  fontWeight: '500',
                  marginBottom: '0.5rem',
                  color: '#1d1d1f'
                }}>
                  Error Details (Dev Mode)
                </summary>
                <div style={{
                  marginTop: '1rem',
                  fontFamily: 'monospace',
                  fontSize: '12px',
                  color: '#d1180b',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word'
                }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && (
                    <div style={{ marginTop: '0.5rem', color: '#6e6e73' }}>
                      {this.state.errorInfo.componentStack}
                    </div>
                  )}
                </div>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
